import { render } from "./sk-privacy-popup.vue?vue&type=template&id=2105295d"
const script = {}

import "./sk-privacy-popup.vue?vue&type=style&index=0&id=2105295d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__